import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { RequirementsService } from '../../../components/sales/requirements/pages/requirements/requirements.service';

@Component({
  selector: 'app-common-tab',
  templateUrl: './common-tab.component.html',
  styleUrls: ['./common-tab.component.scss']
})
export class CommonTabComponent implements OnInit {
  @Input() active:number = 1;
  @Input() tabData: { id: number, label: string, component: any }[] = [];
  @Input() tabClass:string = '';
  @Input() ngClass:string = '';
  @Input() listClass:string = '';
  dropdownOpen: boolean = false;
  constructor(public requirementsService: RequirementsService) { }

  ngOnInit(): void {
  }
  activeTab(id: number) {
    this.active = id;
    this.requirementsService.onRowClicked.next(false);
  }
  onTabClick(tabId: number) {
    if (tabId !== 22 && tabId !== 33) {
      this.activeTab(tabId);
    } else {
    }
  }
  toggleDropdown() {
    this.dropdownOpen = !this.dropdownOpen;
  }

  getSelectedTabLabel(): string {
    const activeTab = this.tabData.find(tab => tab.id === this.active);
    return activeTab ? activeTab.label : '';
  }

  selectTab(tabId: number) {
    this.activeTab(tabId);
    this.dropdownOpen = false;
  }
}